<template>
    <form :action="action" class="registration-form validate-phone" method="POST">
        <input type="hidden" name="_token" :value="csrkToken" />

        <md-card class="profil-form profil-form-mobile">
            <md-card-content>
                <div class="title">{{ $t('registration.validate-phone.title') }}</div>
                <div class="description">
                    {{ $t('registration.validate-phone.description', {
                    phone: user.phone
                    }) }}
                </div>
                <div class="code">
                    <md-field :class="{'md-invalid': !!errors.code}">
                        <md-input
                            autocomplete="one-time-code"
                            name="phone_confirmation"
                            v-model="fData.code"
                            :disabled="submitting ? 'disabled' : null"
                            required
                        />
                        <span class="md-error">{{ errors.code ? errors.code[0] : '' }}</span>
                    </md-field>
                </div>
                <div class="resend">
                    <span @click="resendCode">
                        <u>{{ $t('registration.validate-phone.resend-code') }}</u>
                    </span>
                </div>
            </md-card-content>
            <div class="form-row form-row-submit">
                <div class="form-submit-button">
                    <submit-button
                        type="submit"
                        class="registration-standalone-button"
                        :submitting="submitting"
                        :label="$t('registration.validate-phone.confirm')"
                        @click="onSubmit()"
                        dusk="submit-profile-button"
                    />
                </div>
            </div>
        </md-card>
        <md-snackbar :md-active.sync="showSnackbar">
            <span>{{ $t('registration.validate-phone.resend-code-snackbar') }}</span>
        </md-snackbar>
    </form>
</template>

<script>
export default {
    props: {
        action: {
            type: String,
            required: true,
        },
        actionResend: {
            type: String,
            required: true,
        },
        user: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            fData: {
                code: "",
            },
            errors: {
                code: null,
            },
            csrkToken: Laravel.csrfToken,
            submitting: false,
            showSnackbar: false,
        };
    },
    computed: {},
    mounted() {},
    methods: {
        onSubmit() {
            this.submitting = true;

            for (let i of Object.keys(this.errors)) {
                this.errors[i] = null;
            }

            axios
                .post(this.action, {
                    ...this.fData,
                })
                .then(({ data }) => {
                    if (data.status === "ok") {
                        window.location = data.redirect;
                    }

                    this.submitting = false;
                })
                .catch(
                    ({
                        response: {
                            data: { errors },
                        },
                    }) => {
                        this.submitting = false;

                        for (let i of Object.keys(this.errors)) {
                            this.errors[i] = errors[i];
                        }
                    }
                );
        },
        resendCode() {
            axios
                .post(this.actionResend)
                .then(({ data }) => {
                    this.showSnackbar = true;
                })
                .catch(({ response }) => {
                });
        },
    },
};
</script>
<style lang="scss">
@import "~styles/_variables";
.registration-form {
    height: 100vh;
    .md-title em {
        font-weight: 400;
        font-size: 0.95em;
    }
}
.validate-phone {
    .title {
        font-weight: 600;
        color: $primary-color-dark;
        margin-bottom: 10px;
    }
    .description {
        font-size: 12px;
        color: $primary-color-dark;
    }
    .resend {
        margin-top: 20px;
        color: $primary-color-dark;
        font-size: 12px;
        text-align: center;
        span {
            cursor: pointer;
        }
    }
}
.profil-form-mobile {
    display: flex;
    flex-direction: column;
    justify-content: center;
    .text-grey-light {
        color: rgba(0, 0, 0, 0.54);
        i {
            font-size: 10px;
        }
    }
    padding: 20px;
    .md-card-header {
        .md-title {
            font-size: 20px !important;
        }
    }
    .md-card-content {
        .md-field {
            label {
                font-size: 12px;
            }
        }
        .md-checkbox-label {
            font-size: 10px !important;
        }
    }
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/registration/Profile/formValidatePhone.vue